// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// --- FIREBASE CONFIGURATION & INITIALIZATION ---
const firebaseConfig = {
  apiKey: 'AIzaSyARa2GgSRdiG05O0GhjVPFcfTJzdA9_l7M',
  authDomain: 'smb-suite-platform.firebaseapp.com',
  projectId: 'smb-suite-platform',
  storageBucket: 'smb-suite-platform.firebasestorage.app',
  messagingSenderId: '25729813177',
  appId: '1:25729813177:web:cb4eef969d8b8125826968'
};

// Initialize Firebase and all required services ONCE and export them.
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
